/* eslint-disable @typescript-eslint/no-empty-function */
import { BrowserMicroSentryClient } from '@micro-sentry/browser'

let sentryClient: BrowserMicroSentryClient

export const setupSentry = (): BrowserMicroSentryClient => {
  if (!sentryClient) {
    sentryClient = new BrowserMicroSentryClient({
      dsn: 'https://bc3e173cf2ebdb4d7030adbf1971142e@o24547.ingest.sentry.io/4506139648327680',
      release: process.env.APP_VERSION,
      environment: `${process.env.ENVIRONMENT}`.split('-')[1]
    })
  }

  return sentryClient
}

export const getSentryClient = (): BrowserMicroSentryClient => {
  if (!sentryClient) {
    throw new Error('Sentry client not initialized')
  }

  return sentryClient
}

export const reportError = (params: any, error: any) => {
  const client = getSentryClient()

  try {
    client.setExtras(params)
    client.report(error)
  } catch (err) {
    client.report(err)
  }
}
